module.exports = require("./ha-NE.d.ts");